import { render, staticRenderFns } from "./GlobalProgress.vue?vue&type=template&id=6f2a4c5c&"
import script from "./GlobalProgress.vue?vue&type=script&lang=js&"
export * from "./GlobalProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports